import { z } from 'zod';
/**
 * Genres Booknest — calés sur les catégories Google Books principales.
 * Libellés FR en UI, sauf marketing terms anglicisés (Romance, Dark Romance,
 * Romantasy, Fantasy, Thriller, Horror, Young Adult, Feel-good) qui restent
 * en EN car c'est l'usage courant chez les lecteurs cible.
 *
 * `other` est le fallback pour tout ce qui ne tombe dans aucune catégorie.
 */
export const BookGenreSchema = z.enum([
    'fiction',
    'romance',
    'dark-romance',
    'romantasy',
    'fantasy',
    'science-fiction',
    'thriller',
    'policier',
    'mystery',
    'horror',
    'young-adult',
    'feel-good',
    'historique',
    'classique',
    'litterature-fr',
    'biographie',
    'histoire',
    'essai',
    'dev-perso',
    'poesie',
    'bd-manga',
    'jeunesse',
    'other',
]);
export const IsbnSchema = z
    .string()
    .regex(/^(?:\d{9}[\dX]|\d{13})$/, 'ISBN invalide')
    .transform((s) => s.replace(/-/g, ''));
export const BookSchema = z.object({
    id: z.string().uuid(),
    isbn: IsbnSchema.nullable(),
    openLibraryId: z.string().nullable(),
    googleBooksId: z.string().nullable(),
    title: z.string().min(1).max(500),
    author: z.string().min(1).max(255),
    genre: BookGenreSchema,
    pages: z.number().int().positive().nullable(),
    year: z.number().int().min(1000).max(2100).nullable(),
    coverUrl: z.string().url().nullable(),
    synopsis: z.string().max(5000).nullable(),
    releaseDate: z.string().datetime().nullable(),
    rating: z.number().min(0).max(5).nullable(),
    ratingsCount: z.number().int().nonnegative().nullable(),
    tags: z.array(z.string()).max(20).default([]),
});
export const BookSearchQuerySchema = z.object({
    q: z.string().min(1).max(200),
    limit: z.coerce.number().int().min(1).max(50).default(20),
    offset: z.coerce.number().int().min(0).default(0),
    genre: BookGenreSchema.optional(),
});
//# sourceMappingURL=book.schema.js.map